import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "m3.307 3.307 25.385 25.385a8.15 8.15 0 0 1-3.035 2.078C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .524-2.505 2.441-4.568",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.889 3.083c-.247-.167-.409-.068-.376.171.43.532.505 1.293.526 1.315.527.655.381 1.06 1.044 1.56.365.228.096.937.107 1.314 0 .239-.172.21-.323.182-1.186-1.083-2.362-1.086-3.398-1.4-.405-.043-.412.15-.28.256.725.77 2.603 1.917 2.754 2.01.172.142.946.919.946.94.01.481-.247.855-.323 1.005-.135.51-.408.598-.408.598-2.216 1.486-3.377 1.87-6.969 1.41-.053-.028-.397.03 0 .172.915.303 3.16.788 5.332-.234.522-.364.87-.245 1.249-.462.62-.38 1.506-.854 1.667-.907.484-.257 1.84-.545 2.151-.802.358-.028.73-.075.755-.381.118-.076.29-.02.418-.27.284-.05.236-.15.236-.15-.072-.2-.337-.282-.527-.428-.28-.092-.473-.12-.678-.021-.204.158-.494.043-.494.021-.67-.036-.604-2.24-.84-3.159-.155-.605-1.533-1.91-2.57-2.74",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m5.998 12.576-.448.418.048-.618L5 12.278l.502-.348-.298-.54.578.186.226-.576.219.579.58-.178-.305.536.498.354-.6.09.04.619zm.509 4.188L6.202 17l.107-.38L6 16.39l.38-.011.113-.379.127.374.38-.004-.3.242.12.376zm-.957 5.23.448-.418.443.424-.04-.62.599-.09-.498-.353.306-.536-.581.178L6.008 20l-.226.576-.578-.186.298.54-.502.348.598.098zm-3.552-5.418-.448.418.048-.618L1 16.278l.502-.348-.298-.54.578.186.226-.576.219.579.58-.178-.305.536.498.354-.6.09.04.619zm6.552-.582.448-.418.443.424-.04-.62.599-.09-.498-.353.306-.536-.581.178L9.008 14l-.226.576-.578-.186.298.54-.502.348.598.098z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M14.704 15.02c.25.001.38.02.413.19.59.103 1.583-.152 2.2-.976 0 0 0-.712.274-.25.076-.027.18-.201.267-.312 0-.128.066-.453.245-.084.116.08.326.006.342.006.038-.146.13-.099.18-.072-.045.524.1.547.089.816.005.3-.089.385-.089.5.03.14.462.144.31.263-.134.073 0 .21-.2.263-.585.304-.844.848-.86.848-.026.05-.38.082-.338.31.157.858-.34 1.55-.26 2.24-.435.008-.769-.086-.94-.12.167-.742.102-1.393.102-1.46-.043-.53-.775-.4-.887-.471-.093-.02-.153-.188-.43-.178-.292.283-.556-.17-.556-.17.014-.1-.656.02-1.02-.067-.15.085-.294.596-.579.227 0-.34.442-.456.518-.534.025-.71.27-.545.34-.595.073-.05.104-.379.036-.468 0 0-.743-.433-.14-.734.264.37.662.99.983.828",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCxr = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCxr_default = SvgFlagCxr;

export { FlagCxr_default as default };
